/** 全螢幕銷售子頁：右上角分店＋權限由 SalesIndex 固定層統一渲染 */
export const SALES_FIXED_USER_BRANCH_PAGINATIONS = new Set([
  "index",
  "dashboard",
  "checkoutrecord",
  "appointment-checkoff",
  "consumablesrecord",
  "balance-payment",
]);

/** 子頁自帶 toolbar 分店列，或 SalesIndex 固定層；隱藏 NewHeader 重複 cluster */
export const SALES_HIDE_HEADER_USER_BRANCH_PAGINATIONS = new Set([
  ...SALES_FIXED_USER_BRANCH_PAGINATIONS,
  "checkoutrecord",
  "consumablesrecord",
  "balance-payment",
]);

export function usesSalesFixedUserBranchSlot(pagination) {
  return SALES_FIXED_USER_BRANCH_PAGINATIONS.has(pagination);
}

export function shouldHideSalesHeaderUserBranch(pagination) {
  return SALES_HIDE_HEADER_USER_BRANCH_PAGINATIONS.has(pagination);
}

function salesPaginationFromPath(pathname) {
  if (!pathname?.startsWith("/sales")) return null;
  const segment = pathname.replace(/^\/sales\/?/, "").split("/")[0];
  return segment && segment !== "index" ? segment : "index";
}

export function usesSalesFixedUserBranchSlotFromPath(pathname) {
  const pagination = salesPaginationFromPath(pathname);
  return pagination != null && usesSalesFixedUserBranchSlot(pagination);
}

export function shouldHideSalesHeaderUserBranchFromPath(pathname) {
  const pagination = salesPaginationFromPath(pathname);
  return pagination != null && shouldHideSalesHeaderUserBranch(pagination);
}
